import React from 'react';

import {
    Col,
    FormGroup,
    Label,
    FormFeedback,
    Input,
    InputGroup
} from 'reactstrap';

import { Field } from 'formik';

export const InputTextArea = (props) => {

    const { col, name, label, placeholder, plusChange, rows, showLabel, bottomText, disabled } = props;

    return (
        <Col md={col}>

            <FormGroup>

                {showLabel ? <Label htmlFor={'id_' + name} >{label}</Label> : <React.Fragment />}
                <Field name={name}>
                    {({ field, form, meta }) => (
                        <>
                            <InputGroup>
                                <Input
                                    {...field}
                                    name={name}
                                    value={field.value ?? ''}
                                    as='textarea'
                                    type={props.type}
                                    placeholder={placeholder}
                                    id={'id_' + name}
                                    invalid={meta.error && meta.touched}
                                    className='form-control'
                                    autoComplete="off"
                                    disabled={disabled}
                                    style={{
                                        borderColor: meta.error && meta.touched ? 'red' : 'none',
                                        backgroundColor: disabled ? '#e9ecef' : 'white',
                                        cursor: disabled ? 'not-allowed' : 'text'
                                    }}
                                    rows={rows}
                                    onChange={(e) => {
                                        form.handleChange(e);
                                        plusChange(e);
                                    }}
                                />
                                <FormFeedback>{meta.error}</FormFeedback>
                            </InputGroup>
                            <span style={{ fontStyle: 'italic', fontSize: '12px' }}>{bottomText}</span>
                        </>
                    )}
                </Field>
            </FormGroup>

        </Col>
    )

};

InputTextArea.defaultProps = {
    col: 12,
    rows: 5,
    type: 'textarea',
    showLabel: true,
    plusChange: () => { }
};